<template>
    <div>
<!--        <div class="title">-->
<!--            <p class="return" @click="back"><</p>-->
<!--            全国异地证办理查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="handlingId" clearable label="身份证号:" placeholder="请输入身份证号"/>
            <verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="query">查询</van-button>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 全国异地办证查询
     * Author: Wangyan
     * Date: 2019-03-25
     * Time: 16:41
     */
    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import { idCardRegex } from '@/utils/regex'
    import {memberApi} from "../../api/member";

    export default {
        name: "StrangerQuery",
        components: {
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                handlingId: '', // 办件编号
                receiveVerificationCode: {} // 接收验证码子组件传来verificationInfo对象
            }
        },
        mounted() {
            this.initUser()
        },
        methods: {
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },
            /**
             * 初始化用户
             */
            // 用户信息非必需
            async initUser() {
                let _self = this;
                let userInfo = {};
                try {
                    const res = await _self.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
                    console.log("用户信息")
                    console.log(res)
                    if (res.data.succ) {
                        userInfo = res.data.data
                        this.handlingId=userInfo.idNum
                    } else {
                        Toast.fail('网络异常，请检查网络')
                    }
                } catch (e) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(e)
                }
                return userInfo;
            },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            // genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            // validCode: this.receiveVerificationCode.verificationCode
                            idNum: this.handle,
                            type: this.type
                        }
                        const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.makecard}`, data)
                        if (res.data.data) {
                            Toast.clear()
                            this.$router.push({
                                path: '/myHandlingScheduleQueryDetails',
                                query: {data: JSON.stringify(res.data.data)}
                            })
                        } else {
                            Toast.fail('查询失败')
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                    } catch (error) {
                        // Toast.fail('服务器运行失败，请稍后再试。')
                        Toast.fail('服务维护中，给您带来的不便进请原谅！')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style scoped>
    .title {
        padding: 20px 10px 10px 10px;
        height: 80px;
        font-size: 32px;
        color: #fff;
        background-color: #1989fa;
        position: relative;
        text-align: center;
    }
    .return img {
        font-size: 40px;
        width: 18px;
        height: 29px;
        position: fixed;
        left: 0.4rem;
        top: 0.35rem;
    }


</style>
